import React, { useCallback, useRef, useState } from "react";
import { HexColorPicker } from "react-colorful";
import useClickOutside from "../../hooks/useClickOutside.jsx";
import "./ColorPicker.scss";

const ColorPicker = ({ colorPicker, onColerPickerChange }) => {
  const popover = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => setIsOpen(false), []);
  useClickOutside(popover, close);

  return (
    <div className="component-elements-color-picker-container">
      <div className="swatch" style={{ backgroundColor: colorPicker }} onClick={() => setIsOpen(true)} />

      {isOpen && (
        <div className="popover" ref={popover}>
          <HexColorPicker color={colorPicker} onChange={onColerPickerChange} />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
